import React, { Component } from "react";
import { Col, Container, Row, Carousel } from "react-bootstrap";
import "./Style.scss";
import hero from "../../../Assets/Images/hero.svg";

export class Header extends Component {
  render() {
    return (
      <>
        <section className="homeHeaderSectionContainer">
          <Container className="homeHeaderContainer">
            <Row className="rows">
              <Col lg={6} md={6} sm={12} xs={12} className="leftCol">
                <div className="homeLeftHeader">
                  <h1 className="subTitle">A Healthier Investment Platform</h1>
                  <p className="disc">
                    Groundbreaking innovations presented with simplified
                    usability, investing in the stock market has never been this
                    easy.
                  </p>
                  <a href="#link" className="btn" type="submit" value="Submit">
                    Open a Trading Account
                  </a>
                </div>
              </Col>
              <Col lg={6} md={6} sm={12} xs={12} className="rightCol">
                <div className="homeRightHeader">
                  <img
                    src={hero}
                    alt="OPG Securities hero page"
                    className="heroImg"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default Header;
